import { CircleInfo } from "@gravity-ui/icons";
import {
  Button,
  Flex,
  Icon,
  Popover,
  Text,
  TextInput,
} from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import cn from "classnames";
import { useCallback } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { Form, useNavigate } from "react-router-dom";
import { appConfig } from "src/config";
import { AUTH_TELEGRAM_BOT_LOGIN } from "src/constants/constants";
import {
  getMeTelegramRequest,
  logoutTelegramRequest,
  signUpTelegramRequest,
} from "src/pages/ProfilePage/widgets/UserDataWidget/store/fetchers";
import { checkTelegramData } from "src/pages/ProfilePage/widgets/UserDataWidget/util/checkTelegramData";
import { RoutesPaths } from "src/routes/RoutesPaths";
import { TelegramAuth } from "src/widgets";

import { finalyRegistrationRequest } from "../store/fetchers";
import { notificationAtom } from "../store/notification";
import css from "./FinalyRegistrationPage.module.scss";
import { FinalyRegFormInput } from "./FinalyRegistrationPage.types";

export const FinalyRegistrationPage = () => {
  const navigate = useNavigate();
  const setNotification = useAction(notificationAtom);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FinalyRegFormInput>({
    mode: "onChange",
  });

  const [telegramInfo] = useAtom(getMeTelegramRequest.dataAtom);
  const signUpTelegram = useAction(signUpTelegramRequest);
  const logoutTelegram = useAction(logoutTelegramRequest);

  const finalyRegistration = useAction(finalyRegistrationRequest);

  const onSubmit: SubmitHandler<FinalyRegFormInput> = useCallback(
    async (data) => {
      await finalyRegistration(data)
        .then(() => {
          setNotification({
            theme: "success",
            message: "Успешная верификация",
          });
        })
        .catch(() => {
          setNotification({
            theme: "danger",
            message:
              "Произошла ошибка во время завершения регистрации. Попробуйте ещё раз",
          });
        });

      navigate(RoutesPaths.LK.PROFILE.BASE_PATH, { replace: true });
    },
    [finalyRegistration, navigate, setNotification],
  );

  return (
    <Flex className={cn(css.main, css.full)}>
      <Flex className={cn(css.main, css.mainContainer)}>
        <Flex className={css.main}>
          <appConfig.logo
            height={50}
            onClick={() => navigate(RoutesPaths.LANDING)}
            className={css.footerLogo}
          />
          <Text variant="display-1">Завершение регистрации</Text>
        </Flex>
        <Form className={css.regForm} onSubmit={handleSubmit(onSubmit)}>
          <div className={css.regFormInputContainer}>
            <TextInput
              placeholder="Фамилия"
              {...register("lastName", {
                required: "Обязательное поле",
                minLength: {
                  value: 4,
                  message: "Минимальная длинна 4",
                },
                maxLength: { value: 30, message: "Максимальная длинна 30" },
              })}
              size="xl"
              label="Фамилия"
              type="text"
              validationState={errors.lastName ? "invalid" : undefined}
              errorMessage={errors.lastName?.message}
              errorPlacement="outside"
            />
          </div>
          <div className={css.regFormInputContainer}>
            <TextInput
              placeholder="Имя"
              {...register("firstName", {
                required: "Обязательное поле",
                minLength: {
                  value: 4,
                  message: "Минимальная длинна 4",
                },
                maxLength: { value: 30, message: "Максимальная длинна 30" },
              })}
              size="xl"
              label="Имя"
              type="text"
              validationState={errors.firstName ? "invalid" : undefined}
              errorMessage={errors.firstName?.message}
              errorPlacement="outside"
            />
          </div>

          <div className={css.regFormInputContainer}>
            <TextInput
              placeholder="Отчество"
              {...register("middleName", {
                minLength: {
                  value: 4,
                  message: "Минимальная длинна 4",
                },
                maxLength: { value: 30, message: "Максимальная длинна 30" },
              })}
              size="xl"
              label="Отчество"
              type="text"
              validationState={errors.middleName ? "invalid" : undefined}
              errorMessage={errors.middleName?.message}
              errorPlacement="outside"
            />
          </div>

          <Flex direction={"column"} gap={4}>
            <Flex gap={2} alignItems={"center"}>
              <Text variant="subheader-2">Привязать аккаунт Telegram</Text>
              <Popover
                openDelay={200}
                content={
                  "Привязав аккаунт телеграм Вы получите возможно неделю использовать наш сервис БЕСПЛАТНО"
                }
              >
                <Icon data={CircleInfo} size={18} />
              </Popover>
            </Flex>

            <TelegramAuth
              botUsername={AUTH_TELEGRAM_BOT_LOGIN}
              userImage={false}
              user={telegramInfo}
              requestAccess={true}
              onTelegramAuth={(user) => signUpTelegram(checkTelegramData(user))}
              onLogout={logoutTelegram}
            />
          </Flex>
          <Flex
            className={css.regFormInputContainer}
            direction={"column"}
            alignItems={"center"}
            gap={"3"}
          >
            <Button
              className={css.regButton}
              view="action"
              size="l"
              type="submit"
              width="max"
            >
              Завершить
            </Button>
          </Flex>
        </Form>
      </Flex>
    </Flex>
  );
};
